import { render, staticRenderFns } from "./NeedleSizeDropdown.vue?vue&type=template&id=285e8ff0&scoped=true"
import script from "./NeedleSizeDropdown.vue?vue&type=script&lang=js"
export * from "./NeedleSizeDropdown.vue?vue&type=script&lang=js"
import style0 from "./NeedleSizeDropdown.vue?vue&type=style&index=0&id=285e8ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e8ff0",
  null
  
)

export default component.exports